import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';

/**
 * OIDC Callback Page
 * Handles the redirect from the authentication server
 * Processes the auth code and redirects to original destination
 */
export default function CallbackPage() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Wait for auth to finish processing the callback
    if (!auth.isLoading) {
      if (auth.isAuthenticated) {
        // Get the original URL the user was trying to access
        const state = auth.user?.state as { returnUrl?: string } | undefined;
        const returnUrl = state?.returnUrl || '/';

        // Redirect back to the original destination
        navigate(returnUrl, { replace: true });
      } else if (auth.error) {
        // Authentication failed
        console.error('Authentication error:', auth.error);
        navigate('/', { replace: true });
      }
    }
  }, [auth.isLoading, auth.isAuthenticated, auth.error, auth.user, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
        <p className="text-neutral-600">Completing authentication...</p>
      </div>
    </div>
  );
}
